import { defineLocaleResourceBundle } from "sanity";
/**
* The locale namespace for the vision tool
*
* @internal
*/
const visionLocaleNamespace = "vision", visionUsEnglishLocaleBundle = defineLocaleResourceBundle({
	locale: "en-US",
	namespace: visionLocaleNamespace,
	resources: () => import("./resources-VRZHPMVB.js")
});
export { visionUsEnglishLocaleBundle as n, visionLocaleNamespace as t };

//# sourceMappingURL=i18n-DFRqoJ_F.js.map